import { tw } from "@careinfo/tailwind";
import loadable from "@loadable/component";
import { UseFormSetError } from "react-hook-form";
import { toast } from "react-toastify";
import APIS from "../../constant/Endpoint";
import usePostHook from "../../hooks/usePostHook";
import CreateIcon from "../../icons/CreateIcon";
import { INavigation } from "../../types/interface";

const CreateNavigationComponent = loadable(
  () => import("../../components/Navigation/Create")
);

export default function CreateNavigation() {
  const { mutateAsync: createNavigation, isLoading: isCreatingNavigation } =
    usePostHook({
      queryKey: ["create-navigation"],
      navigateURL: "/website-builder/navigation",
    });

  const handleCreate = async (
    data: INavigation,
    setError: UseFormSetError<INavigation>
  ) => {
    try {
      const url = APIS.NAVIGATION;
      await createNavigation({
        url,
        formData: { ...data, pages: data.pages.id },
        setError,
      });
    } catch (e) {
      if (e instanceof Error) toast.error(e.message);
    }
  };

  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Create Navigation
        </span>
      </div>
      <CreateNavigationComponent
        handleCreate={handleCreate}
        isCreatingNavigation={isCreatingNavigation}
      />
    </>
  );
}
